import Firebase from 'firebase';

const config = {
  apiKey: 'AIzaSyDhVYJcV4QL8XG__0DytA2utCDl61NXHWA',
  authDomain: 'worldspaceschool-stg.firebaseapp.com',
  databaseURL: 'https://worldspaceschool-stg.firebaseio.com',
  storageBucket: 'worldspaceschool-stg.appspot.com'
};

Firebase.initializeApp(config);

const Database = Firebase.database().ref();
const Storage = Firebase.storage().ref();
const Auth = Firebase.auth();

export {
  Auth,
  Database,
  Storage
};


/** WEBPACK FOOTER **
 ** ./src/js/firebaseInit.js
 **/